import React from 'react';
import { BookOpenIcon, CalendarDaysIcon, CircleCheckIcon, PrinterIcon } from 'lucide-react';
import { heroPoints, mockupAlt, mockupImage } from '../data/kit';
export function Hero() {
  return <section className="hero night" data-id="element-88" data-mp="9ka68zwg6uxg">
      <div className="wrap hero-grid" data-id="element-89" data-mp="9lbfcytwl7cj">
        <div data-id="element-90" data-mp="4lql31pohn65">
          <p className="hero-pill" data-id="element-91" data-mp="4m8n6ez0uvlz">Weekly planning for children's activity leaders</p>
          <h1 data-id="element-92" data-mp="1297bo2fk8x8s">
            Your next 13 weeks of kids’ activities. <span className="accent" data-id="element-93" data-mp="128yzydv6bxz6">Already planned.</span>
          </h1>
          <div className="mobile-product" data-id="element-94" data-mp="xbfk59itvd54">
            <img className="product-mockup" src={mockupImage} alt={mockupAlt} data-id="element-95" data-mp="x8b6zmndx72b" />
          </div>
          <p className="hero-description" data-id="element-96" data-mp="sde30u4ypnwa">
            <strong data-id="element-97" data-mp="ncq47mahs2ri">Kids Activity Club — Volume 1</strong> gives you 13 complete weekly encounters: the games,
            materials, instructions, timing and printable resources. Open the week, prepare your materials and
            lead the group.
          </p>
          <ul className="hero-list" data-id="element-98" data-mp="384s62qvt8p44">
            {heroPoints.map(point => <li key={point} data-id="element-99" data-mp="3j9ahhe4fas5o">
                <CircleCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-100" data-mp="3o7lq5lizewmb" />
                {point}
              </li>)}
          </ul>
          <a className="cta" href="#offer-details" data-id="element-101" data-mp="399tc6xt32ga8">
            GET MY 13-WEEK ACTIVITY KIT
          </a>
          <div className="micro-row" data-id="element-102" data-mp="3e7l6fyh7aehl">
            <span data-id="element-103" data-mp="30ib0az366mmy">
              <BookOpenIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-104" data-mp="30hrf99i83i4p" />
              Digital resources
            </span>
            <span data-id="element-105" data-mp="35aawqhk16xes">
              <PrinterIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-106" data-mp="35aklk1tcayiw" />
              Ready to print
            </span>
            <span data-id="element-107" data-mp="2vieuqvetqn5a">
              <CalendarDaysIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-108" data-mp="2vjzqupgsee59" />
              One week at a time
            </span>
          </div>
        </div>
        <div className="hero-product" data-id="element-109" data-mp="2lkilya9d04ac">
          <img className="product-mockup" src={mockupImage} alt={mockupAlt} data-id="element-110" data-mp="2ljgy1578vnb7" />
          <p className="product-caption" data-id="element-111" data-mp="s2b921mmap6q">Your next 13 weeks, mapped out</p>
        </div>
      </div>
    </section>;
}